import { useState, useEffect } from 'react';
import { WindowSize } from './type';

const useWindowSize = (breakpoints: { mobile?: number; tablet?: number } = {}) => {
  const { mobile = 700, tablet = 1000 } = breakpoints;
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: window.innerWidth <= mobile,
    isTablet: window.innerWidth > mobile && window.innerWidth <= tablet,
    isDesktop: window.innerWidth > tablet,
  });

  const handleResize = () => {
    const { innerWidth: width, innerHeight: height } = window;
    setWindowSize({
      width,
      height,
      isMobile: width <= mobile,
      isTablet: width > mobile && width <= tablet,
      isDesktop: width > tablet,
    });
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoints]);

  return windowSize;
};

export default useWindowSize;
